import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RefreshableTimeago from "@Shared/components/general/refreshable-timeago";
import { capitalize } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ListsTable",
  components: {
    RefreshableTimeago
  },
  props: {
    lists: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      columns: ["listid", "name", "description", "lastupdate", "numberemails", "actionbuttons"]
    };
  },
  computed: {
    getLists() {
      return _Object$values(this.lists.byId);
    },
    options() {
      return {
        uniqueKey: "listid",
        hiddenColumns: "listid",
        filterable: false,
        sortable: ["name", "description", "lastupdate", "numberemails"],
        orderBy: {
          column: "lastupdate"
        },
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort"
        },
        headings: {
          name: this.$t("global.words.name"),
          description: this.$t("global.words.description"),
          numberemails: "# " + capitalize(this.$tc("global.words.email", 2)),
          lastupdate: this.$t("global.actions.lastUpdate"),
          actionbuttons: this.$t("global.words.actions")
        },
        perPage: 999999,
        tabbable: false,
        columnsClasses: {
          fullname: "w-25",
          email: "w-30"
        },
        skin: "table table-hover",
        customFilters: [{
          name: "name",
          callback: (row, query) => {
            var _context;
            const searchString = `${row.name} ${row.description}`;
            return _indexOfInstanceProperty(_context = searchString.toLowerCase()).call(_context, query.toLowerCase()) >= 0;
          }
        }],
        texts: {
          noResults: this.$t("lists.noListsToShow")
        }
      };
    }
  },
  methods: {
    segmentLink(listId) {
      return {
        name: "marketing-list-segments",
        params: {
          listId
        }
      };
    },
    toList(listId) {
      this.$router.push({
        path: `/marketing/lists/${listId}/contacts`
      });
    }
  }
});